import React, { useContext } from 'react';
import { Route, Redirect } from "react-router-dom";

import { AuthContext } from '../Context/AuthContext';

function PrivateRoute({ children, ...rest }) {

  const { signedIn } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        signedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export { PrivateRoute };